/** API origin (no `/api` suffix). Set `VITE_HOST_API` in CI/build; falls back in production so SPA host ≠ API host still works. */
const DEFAULT_PROD_API_ORIGIN = 'https://hrmback.mrnware.com';

function resolveApiOriginFromEnv(): string {
    const fromEnv = String(import.meta.env.VITE_HOST_API ?? '').trim();
    if (fromEnv) return fromEnv;
    if (import.meta.env.PROD) return DEFAULT_PROD_API_ORIGIN;
    return '';
}

export const API_GATEWAY_BASE_URL = resolveApiOriginFromEnv();

/**
 * Laravel (and NEW_ENDPOINTS.md) expose JSON under `/api/...`.
 * If `VITE_HOST_API` is origin only (e.g. `https://host`), append `/api`.
 * If it already ends with `/api`, leave unchanged.
 */
export function getResolvedApiBaseUrl(): string {
    const raw = String(API_GATEWAY_BASE_URL ?? '').trim();
    if (!raw) return '';
    const noTrailing = raw.replace(/\/+$/, '');
    if (noTrailing.endsWith('/api')) return noTrailing;
    return `${noTrailing}/api`;
}
